import $ from "jquery";
import axios from "axios";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import AdminService from "./admin.service";
import UserService from "./user.service";
import ReportService from "./report.service";

const API_ADMIN_URL = AdminService.getBaseUrl() + "/api/v1/admin"

class MoatService {
  async importMoatData(file, callback, chartApp) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", UserService.getUserId());

    let headers = { "Content-Type": "multipart/form-data" };
    $.extend(headers, await authHeader());

    await axios
    .post(API_ADMIN_URL + "/import-moat-data", formData, { headers: headers })
    .then(response => callback(response))
    .catch(error => {
      error.message += ErrorService.mergeError(error.response);
      ErrorService.processError("MoatService.importMoatData", error, "admin", chartApp);
    });  

  }
  async getMoatDataList(callback, chartApp) {
    await axios
    .get(API_ADMIN_URL + "/get-moat-data", { headers: await authHeader() })
    .then(response => callback(response))
    .catch(error => {
      error.message += ErrorService.mergeError(error.response);
      ErrorService.processError("MoatList.getMoatDataList", error, "admin", chartApp);
    });    
  }
  getTableColumnData() {
    return [
      {
        title: "ID",
        data: "moatDescriptionId",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-left");
        },
        className: "",
        name: "moatDescriptionId",
        width: "1rem",
        bVisible: true
      },
      { title: "Sector", data: "sectorName", name: "sectorName", class: "text-left", width: "6rem" },
      { title: "Moat Name", data: "name", name: "name", class: "text-left", width: "8rem" },
      { title: "Description", data: "description", name: "description", width: "12rem", class: "text-left description-cell"},
      { title: "Features", data: "features", name: "features", width: "8rem", class: "text-left description-cell"}
    ];
  }

  async getMoatInitiativeDataList(callback, chartApp) {
    await axios
    .get(API_ADMIN_URL + "/get-moat-initiative-data", { headers: await authHeader() })
    .then(response => callback(response))
    .catch(error => {
      error.message += ErrorService.mergeError(error.response);
      ErrorService.processError("MoatList.getMoatInitiativeDataList", error, "admin", chartApp);
    });    
  }
  getMoatInitiativeTableColumnData() {
    return [
      {
        bVisible: true,
        data: "moatInitiativeId",
        render: function(data, type, full, meta) {
          return '<input type="checkbox" name="moatInitiativeId[]" value="' + full.moatInitiativeId + '" >';
        },
        className: "text-center",
        name: "moatInitiativeId",
        width: "1rem"
      },
      {
        title: "ID",
        data: "moatInitiativeId",
        createdCell: function(td, cellData, rowData, row, col) {
          $(td).addClass("text-left");
        },
        className: "",
        name: "moatInitiativeId",
        width: "2rem",
        bVisible: true
      },
      { title: "Sector", data: "sectorName", name: "sectorName", class: "text-left", width: "4rem" },
      { title: "Moat Name", data: "name", name: "name", class: "text-left", width: "6rem" },
      { title: "Sequence No.", data: "sequenceNumber", name: "sequenceNumber", class: "text-center", width: "4rem" },
      { title: "Initiative", data: "initiative", name: "initiative", width: "14rem", class: "text-left description-cell"},
      { title: "Emotion", data: "emotion", name: "emotion", width: "5rem", class: "text-left description-cell"},
      { title: "Success Level", data: "successLevel", name: "successLevel", width: "5rem", class: "text-left description-cell"},
      { title: "Sales % Increase", data: "salesIncrease", name: "salesIncrease", width: "5rem", class: "text-left description-cell"},
      { title: "Cost % Reduction", data: "costReduction", name: "costReduction", width: "5rem", class: "text-left description-cell"}
    ];
  }

  async importMoatInitiativeData(file, callback, chartApp) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", UserService.getUserId());

    let headers = { "Content-Type": "multipart/form-data" };
    $.extend(headers, await authHeader());

    await axios
    .post(API_ADMIN_URL + "/import-moat-initiative-data", formData, { headers: headers })
    .then(response => callback(response))
    .catch(error => {
      error.message += ErrorService.mergeError(error.response);
      ErrorService.processError("MoatService.importMoatInitiativeData", error, "admin", chartApp);
    });  
  }

  async deleteMoatInitiatives(moatInitiativeIds,callback,app){
    const params = new URLSearchParams();
    params.append("moatInitiativeIds", moatInitiativeIds);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_ADMIN_URL + "/delete-moat-initiatives", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("MoatService.deleteMoatInitiatives", error, "admin", app);
      });
  }

  buildSectorOptionList(moatInitiativesList) {
    const list = [];
    list.push({ name: "Select Sector", value: 0 });
    const sectorFilteredList = [...new Set(moatInitiativesList.map(x => x.sectorId))]
      .map(sectorId => {
        return {
          sectorId: sectorId,
          sectorName: moatInitiativesList.find(s => s.sectorId == sectorId).sectorName
        };
      });
    if (sectorFilteredList.length > 0) {
      sectorFilteredList.sort(ReportService.compareValues("sectorId", "asc"));
      sectorFilteredList.forEach(moatInitiative => {
        const option = {
          name: moatInitiative.sectorName,
          value: moatInitiative.sectorId,
        };
        list.push(option);
      });

    }
    return list;
  }

  buildMoatOptionList(initiativeList, sectorId = 0) {
    const list = [];
    list.push({
      name: "Select Moat Name",
      value: ""
    });
    if (sectorId != 0){
      initiativeList = initiativeList.filter(s => Number(s.sectorId) == Number(sectorId));
    }
    const moatFilteredList = [...new Set(initiativeList.map(x => x.name))]
      .map(name => {
        return {
          name: name
        };
      });

    if (moatFilteredList.length > 0) {
      moatFilteredList.sort(ReportService.compareValues("name", "asc"));

      moatFilteredList.forEach(initiative => {
        const option = {
          name: initiative.name,
          value: initiative.name  // Bind value to name string
        };
        list.push(option);
      });
    }

    return list;
  }

  getInitiativesBySector(originalList, sectorIdToCompare){
    if (typeof originalList != "undefined") {
      return originalList.filter(input => Number(input.sectorId) == Number(sectorIdToCompare));
    }
    
    return {};
  }

  getInitiativesByMoatName(originalList, moatNameToCompare){
    if (typeof originalList != "undefined") {
        return originalList.filter(input => String(input.name) == String(moatNameToCompare));
    } 
    return {};
  }
}
export default new MoatService();
